import { InjectionToken, type Type } from '@angular/core';

/**
 * Contract for a per-eventType timeline renderer: a standalone @Component that exposes
 * an `event` input of type {@link import('../../../../../core/api/generated/models/ConversationEvent').ConversationEvent}.
 * The host swaps between registered components via `NgComponentOutlet`, with a fallback
 * for unknown types — adding a new event type means: register a new entry, no host changes.
 *
 * The component type is intentionally widened (`Type<object>`) because Angular signal
 * inputs do not satisfy interface fields; binding correctness is enforced at runtime by
 * `NgComponentOutlet` and by the component's own template type checking.
 */
export interface EventRendererEntry {
  /** Concrete eventType (e.g. `conversation.label_added`). `'*'` declares the fallback. */
  readonly eventType: string;
  /** Standalone component class with an `event` input of `ConversationEvent`. */
  readonly component: Type<object>;
}

/** Multi-provider token: every renderer entry contributes one element. */
export const EVENT_RENDERER_REGISTRY = new InjectionToken<readonly EventRendererEntry[]>(
  'CONVERSATIONS_EVENT_RENDERER_REGISTRY',
);
